import { render, staticRenderFns } from "./FloatingLabel.vue?vue&type=template&id=8ea054e2&scoped=true&"
import script from "./FloatingLabel.vue?vue&type=script&lang=js&"
export * from "./FloatingLabel.vue?vue&type=script&lang=js&"
import style0 from "./FloatingLabel.vue?vue&type=style&index=0&id=8ea054e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea054e2",
  null
  
)

export default component.exports